import type { ComponentProps } from 'react'
import { cn } from '../lib/cn'
export function CenteredLayout({
  className,
  width = 'sm',
  children,
  ...props
}: ComponentProps<'div'> & { width?: 'sm' | 'md' }) {
  return (
    <div
      {...props}
      data-slot="centered-layout"
      className={cn('grid min-h-dvh place-items-center px-5 py-10', className)}
    >
      <div className={cn('w-full min-w-0', width === 'sm' ? 'max-w-md' : 'max-w-2xl')}>
        {children}
      </div>
    </div>
  )
}
